export default __webpack_public_path__ + "static/media/s-squiggle-127.d3077c5a.svg";